<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group (selectedTabChange)="onTabChange($event)">
      <mat-tab *ngFor="let tab of tabs" [label]="tab.name">
        <ng-template matTabContent>
          <div class="px-4 py-2">
            <form class="row mat-form" [formGroup]="filterForm">
              <div class="col-md-12">
                <app-input-select
                  (selectionChange)="getMasterPartnerTransactionSettings()"
                  [inputData]="attrConstant.partner"
                  [selectOptions]="partnerList$ | async"
                  [bindLabel]="'name'"
                  [bindValue]="'partner_id'"
                  [formControlName]="
                    attrConstant.partner.key
                  "></app-input-select>
              </div>
            </form>
            <table mat-table [dataSource]="dataSource" matSort>
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element" data-label="Name">
                  {{ element.name }}
                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                  <ng-container
                    *appHasAccess="'edit-master-partner-transaction-setting'">
                    Action
                  </ng-container>
                </th>
                <td mat-cell *matCellDef="let element" data-label="Action">
                  <div class="d-flex align-items-center action-gap-10">
                    <img
                      src="assets/images/edit-icon.svg"
                      alt="edit-icon"
                      matTooltip="Edit"
                      matTooltipPosition="left"
                      [attr.aria-hidden]="true"
                      (click)="onEdit()"
                      *appHasAccess="
                        'edit-master-partner-transaction-setting'
                      " />
                    <img
                      src="assets/images/delete-icon.svg"
                      alt="delete-icon"
                      matTooltip="Delete"
                      matTooltipPosition="right"
                      [attr.aria-hidden]="true"
                      (click)="onDelete(element)"
                      *appHasAccess="
                        'delete-master-partner-transaction-setting'
                      " />
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="
                  let row;
                  columns: displayedColumns;
                  let element
                "></tr>
            </table>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab
        disabled
        *appHasAccess="'add-master-partner-transaction-setting'">
        <ng-template mat-tab-label>
          <button class="btn primary-btn" (click)="addTransactionSettings()">
            Add {{ currentTabLabel | column }}
          </button>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
